import { render } from "./CustomCalendarViewHeader.vue?vue&type=template&id=5fea8ccf&scoped=true&ts=true&lang=pug"
import script from "./CustomCalendarViewHeader.vue?vue&type=script&lang=ts"
export * from "./CustomCalendarViewHeader.vue?vue&type=script&lang=ts"

import "./CustomCalendarViewHeader.vue?vue&type=style&index=0&id=5fea8ccf&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fea8ccf"]])

export default __exports__